// Mirrors marketplace/src/components/CreateBooking/Daycare/FeedingsAndMedications/UI/{MedicationDosage,FoodQuantity}/*UnitsConfig.ts
// Keep aligned with CSW so OLB does not accept values CSW will later reject.

interface UnitDecimalConfig {
    maxDecimals: number;
    step: number;
}

const MEDICATION_UNIT_CONFIG: Record<string, UnitDecimalConfig> = {
    ml: { maxDecimals: 2, step: 0.1 },
    g: { maxDecimals: 2, step: 0.1 },
    drop: { maxDecimals: 0, step: 1 },
    tbsp: { maxDecimals: 2, step: 0.5 },
    tsp: { maxDecimals: 2, step: 0.5 },
    pill: { maxDecimals: 2, step: 0.5 },
    mg: { maxDecimals: 0, step: 1 }
};

const FOOD_UNIT_CONFIG: Record<string, UnitDecimalConfig> = {
    cup: { maxDecimals: 2, step: 0.25 },
    grams: { maxDecimals: 0, step: 1 },
    ounces: { maxDecimals: 1, step: 0.1 },
    tbsp: { maxDecimals: 1, step: 0.5 },
    tsp: { maxDecimals: 2, step: 0.5 },
    can: { maxDecimals: 0, step: 1 },
    scoop: { maxDecimals: 0, step: 1 },
    piece: { maxDecimals: 0, step: 1 },
    ltrs: { maxDecimals: 2, step: 0.1 },
    ml: { maxDecimals: 0, step: 1 },
    bag: { maxDecimals: 0, step: 1 }
};

const DEFAULT_MAX_DECIMALS = 2;
const DEFAULT_STEP = 0.1;

const lookupKey = (unitName: string | undefined): string => (unitName ?? '').trim().toLowerCase();

export const getMedicationMaxDecimals = (unitName: string | undefined): number =>
    MEDICATION_UNIT_CONFIG[lookupKey(unitName)]?.maxDecimals ?? DEFAULT_MAX_DECIMALS;

export const getMedicationStep = (unitName: string | undefined): number =>
    MEDICATION_UNIT_CONFIG[lookupKey(unitName)]?.step ?? DEFAULT_STEP;

export const getFoodMaxDecimals = (unitName: string | undefined): number =>
    FOOD_UNIT_CONFIG[lookupKey(unitName)]?.maxDecimals ?? DEFAULT_MAX_DECIMALS;

export const getFoodStep = (unitName: string | undefined): number =>
    FOOD_UNIT_CONFIG[lookupKey(unitName)]?.step ?? DEFAULT_STEP;
